export enum LogoutType {
    Default,
    Expires,
    Inactivity,
    Unauthorized,
    ErrorSystem,
  }